import * as ApiRequests from '../../api/requests';
import { AuthHelper } from '../../types/auth-helper-types';
import { AppThunk } from '../actions';
import { StarfishDeviceActions } from '../actions/starfish-device-actions';

export const StarfishDeviceThunks = {
    StarfishDeviceRegistration: (
        StarfishgatewayDeviceData: {
            name: string;
            serial: string;
            siteId: string;
            deviceIp: string;
            deviceProfileId: string;
            mac?: string;
            port?: number | undefined;
            deviceAddress?: number | undefined;
            parentDeviceId?: string;
            pushRate?: number;
            communicationType?: string;
        },
        authHelper: AuthHelper,
        addToast: Function
    ): AppThunk => async (dispatch): Promise<void> => {
        dispatch(StarfishDeviceActions.StarfishGatewayDeviceRegistrationStarted());

        const payload = await ApiRequests.createStarfishGatewayDevice(
            {
                name: StarfishgatewayDeviceData.name,
                deviceIp: StarfishgatewayDeviceData.deviceIp,
                serial: StarfishgatewayDeviceData.serial,
                mac: StarfishgatewayDeviceData.mac,
                siteId: StarfishgatewayDeviceData.siteId,
                deviceProfileID: StarfishgatewayDeviceData.deviceProfileId,
                port: StarfishgatewayDeviceData.port || 0,
                deviceAddress: StarfishgatewayDeviceData.deviceAddress || 0,
                parentDeviceId: StarfishgatewayDeviceData.parentDeviceId || '',
                pushRate: StarfishgatewayDeviceData.pushRate || 1,
                communicationType: StarfishgatewayDeviceData.communicationType || '',
                requestedFrom: 'Remote',
            },
            { authHelper }
        );

        if (payload.ok) {
            dispatch(
                StarfishDeviceActions.StarfishGatewayDeviceRegistrationSucceeded(
                    payload.response.message,
                    payload.response.data,
                    payload.response.data.connectionString || '',
                    payload.response.data.id
                )
            );
        } else {
            const errorCode = ApiRequests.extractResponseNotOkCode(payload.response);

            addToast(ApiRequests.extractResponseNotOkMessage(payload.response), 'error');
            if (errorCode === 4001) {
                addToast(ApiRequests.extractResponseNotOkMessage(payload.response), 'error');
            }
            dispatch(StarfishDeviceActions.StarfishGatewayDeviceRegistrationFailed(errorCode.toString()));
        }
    },
    StarfishGatewayDeviceUpdate: (
        deviceId: string,
        name: string,
        siteId: string,
        deviceIp: string,
        authHelper: AuthHelper,
        addToast: Function,
        mac?: string,
        serial?: string,
        pushRate?: number
    ): AppThunk => async (dispatch): Promise<void> => {
        dispatch(StarfishDeviceActions.StarfishGatewayDeviceUpdateStarted());

        const payload = await ApiRequests.updateStarfishGatewayDevice(
            {
                deviceId: deviceId,
                name: name,
                deviceIp: deviceIp,
                serial: serial ? serial : '',
                mac: mac ? mac : '',
                pushRate: pushRate ? pushRate : 0,
                requestedFrom: 'Remote',
            },
            { authHelper }
        );

        if (payload.ok) {
            dispatch(
                StarfishDeviceActions.StarfishGatewayDeviceUpdateSucceeded(
                    payload.response.message,
                    payload.response.data
                )
            );
        } else {
            const errorCode = ApiRequests.extractResponseNotOkCode(payload.response);

            addToast(ApiRequests.extractResponseNotOkMessage(payload.response), 'error');
            if (errorCode === 4001) {
                addToast(ApiRequests.extractResponseNotOkMessage(payload.response), 'error');
            }
            dispatch(StarfishDeviceActions.StarfishGatewayDeviceUpdateFailed(errorCode.toString()));
        }
    },
    DeleteStarfishGateway: (deviceId: string, authHelper: AuthHelper, addToast: Function): AppThunk => async (
        dispatch
    ): Promise<void> => {
        dispatch(StarfishDeviceActions.DeleteStarfishGatewayStarted());

        const payload = await ApiRequests.deleteStarfishGateway({ deviceId: deviceId }, { authHelper });
        if (payload.ok) {
            dispatch(StarfishDeviceActions.DeleteStarfishGatewaySucceeded(payload.response.message));
        } else {
            addToast(`${ApiRequests.extractResponseNotOkMessage(payload.response)}`, 'error');
            dispatch(StarfishDeviceActions.DeleteStarfishGatewayFailed(payload.httpStatusCode.toString()));
        }
    },
};
export const StarfishChildDeviceThunks = {
    StarfishChildDeviceRegistration: (
        StarfishChildDeviceData: {
            name: string;
            // deviceId: string;
            serial: string;
            siteId: string;
            deviceIp: string;
            deviceProfileId: string;
            mac?: string;
            port?: number | undefined;
            deviceAddress?: number | undefined;
            parentDeviceId?: string;
            pushRate?: number;
            communicationType?: string;
            scanRate?: number;
            requestedFrom?: string;
            deviceType?: string;
            baudRate?: number;
            dataBits?: number;
            stopBits?: number;
            parity?: string;
            comPort?: string;
        },
        authHelper: AuthHelper,
        addToast: Function
    ): AppThunk => async (dispatch): Promise<void> => {
        dispatch(StarfishDeviceActions.StarfishGatewayDeviceRegistrationStarted());

        const payload = await ApiRequests.createStarfishChildDevice(
            {
                name: StarfishChildDeviceData.name,
                deviceIp: StarfishChildDeviceData.deviceIp,
                serial: StarfishChildDeviceData.serial,
                mac: StarfishChildDeviceData.mac,
                siteId: StarfishChildDeviceData.siteId,
                deviceProfileID: StarfishChildDeviceData.deviceProfileId,
                port: StarfishChildDeviceData.port || 0,
                deviceAddress: StarfishChildDeviceData.deviceAddress || 0,
                parentDeviceId: StarfishChildDeviceData.parentDeviceId || '',
                communicationType: StarfishChildDeviceData.communicationType,
                scanRate: StarfishChildDeviceData.scanRate,
                requestedFrom: 'Remote',
                baudRate: StarfishChildDeviceData.baudRate || 0,
                dataBits: StarfishChildDeviceData.dataBits || 0,
                stopBits: StarfishChildDeviceData.stopBits || 0,
                parity: StarfishChildDeviceData.parity,
                comPort: StarfishChildDeviceData.comPort,
                deviceType: StarfishChildDeviceData.deviceType || '',
            },
            { authHelper }
        );

        if (payload.ok) {
            dispatch(
                StarfishDeviceActions.StarfishGatewayDeviceRegistrationSucceeded(
                    payload.response.message,
                    payload.response.data,
                    payload.response.data.connectionString || '',
                    payload.response.data.id
                )
            );
        } else {
            const errorCode = ApiRequests.extractResponseNotOkCode(payload.response);
            addToast(ApiRequests.extractResponseNotOkMessage(payload.response), 'error');
            if (errorCode === 4001) {
                addToast(ApiRequests.extractResponseNotOkMessage(payload.response), 'error');
            }
            dispatch(StarfishDeviceActions.StarfishGatewayDeviceRegistrationFailed(errorCode.toString()));
        }
    },
    StarfishChildDeviceUpdate: (
        deviceId: string,
        name: string,
        serial: string,
        scanRate: number,
        communicationType: string,
        mac: string,
        comPort: string,
        port: number,
        baudRate: number,
        dataBits: number,
        parity: string,
        stopBits: number,
        deviceAddress: number,
        deviceIp: string,
        isDisarm: boolean,
        isActive: boolean,
        authHelper: AuthHelper,
        addToast: Function
    ): AppThunk => async (dispatch): Promise<void> => {
        dispatch(StarfishDeviceActions.StarfishChildDeviceUpdateStarted());

        const payload = await ApiRequests.updateStarfishChildDevice(
            {
                deviceId: deviceId,
                name: name,
                serial: serial,
                mac: mac,
                port: port,
                comPort: comPort,
                baudRate: baudRate,
                dataBits: dataBits,
                parity: parity,
                stopBits: stopBits,
                deviceAddress: deviceAddress,
                deviceIp: deviceIp,
                scanRate: scanRate,
                communicationType: communicationType,
                isDisarm: isDisarm,
                isActive: isActive,
                requestedFrom: 'Remote',
            },
            { authHelper }
        );

        if (payload.ok) {
            dispatch(
                StarfishDeviceActions.StarfishChildDeviceUpdateSucceeded(
                    payload.response.message,
                    payload.response.data
                )
            );
        } else {
            const errorCode = ApiRequests.extractResponseNotOkCode(payload.response);

            addToast(ApiRequests.extractResponseNotOkMessage(payload.response), 'error');
            if (errorCode === 4001) {
                addToast(ApiRequests.extractResponseNotOkMessage(payload.response), 'error');
            }
            dispatch(StarfishDeviceActions.StarfishChildDeviceUpdateFailed(errorCode.toString()));
        }
    },
    DeleteStarfishChildDevice: (deviceId: string, authHelper: AuthHelper, addToast: Function): AppThunk => async (
        dispatch
    ): Promise<void> => {
        dispatch(StarfishDeviceActions.DeleteStarfishChildDeviceStarted());

        const payload = await ApiRequests.deleteStarfishChildDevice({ deviceId: deviceId }, { authHelper });
        if (payload.ok) {
            dispatch(StarfishDeviceActions.DeleteStarfishChildDeviceSucceeded(payload.response.message));
        } else {
            addToast(`${ApiRequests.extractResponseNotOkMessage(payload.response)}`, 'error');
            dispatch(StarfishDeviceActions.DeleteStarfishChildDevicesFailed(payload.httpStatusCode.toString()));
        }
    },
};
